import { Route } from "react-router-dom";
import Signin from "../feature-module/pages/login/signin";
import Pos from "../feature-module/pages/Pos/Pos";
import BackOfHouse from "../feature-module/pages/BackOfHouse/BackOfHouse";
import PortalPage from "../feature-module/pages/portal/PortalPage";
import { all_routes } from "./all_routes";

/* PUBLIC ROUTES */
export const publicRoutes = [
  { id: 1, 
    path: all_routes.signin, 
    element: <Signin />, 
    route: Route },
];

/* POS ROUTES (children only; do NOT use /pos here) */
export const posRoutes = [
  { id: 1, 
    path: "", 
    element: <Pos />, 
    route: Route },
];

/* BACK OFFICE ROUTES (children only) */
export const pagesRoute = [
  { id: 1, 
    path: "", 
    element: <BackOfHouse />, 
    route: Route },
];

/* PORTAL ROUTES */
export const portalRoutes = [
  { id: 1, 
    path: all_routes.portal, 
    element: <PortalPage />, 
    route: Route },
];

export default { publicRoutes, posRoutes, pagesRoute, portalRoutes };
